import {
    OPEN,
    CLOSE,
    MODE
} from '../actions/message_modal_actions';

const defaultState = {
    heading: 'Message Box',
    content: null,
    contentType: 0,
    buttons: [],
    mode: MODE.hide
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case OPEN:
            return { ...state,
                mode: MODE.show,
                heading: action.payload.heading,
                content: action.payload.content,
                contentType: action.payload.contentType,
                buttons: action.payload.buttons
            };
        
        case CLOSE:
            return { ...state, mode: MODE.hide };
        
        default:
            return state;
    }
}
